import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemTextValue
} from "../../report-design-item";

@Pipe({
  name: "asTextValue",
  standalone: false
})
export class ReportItemConfigAsTextValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemTextValue {
    return <ReportDesignItemTextValue>value;
  }
}
